module.exports = __webpack_public_path__ + "4fc2b173a97c0a5d9735bd94d8ce6fac.svg";